import { render, staticRenderFns } from "./TableForm19.vue?vue&type=template&id=020336d9&scoped=true"
import script from "./TableForm19.vue?vue&type=script&lang=ts"
export * from "./TableForm19.vue?vue&type=script&lang=ts"
import style0 from "./TableForm19.vue?vue&type=style&index=0&id=020336d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020336d9",
  null
  
)

export default component.exports